import axios from '@/plugins/axios'

export default {
    get() {
        return axios.rasaApi.get(`/health_check`)
      },
}